var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticClass:"vs-con-loading__container",staticStyle:{"border-radius":"5px"},attrs:{"type":"gradient","color":"#02a66d","gradient-color-secondary":"rgb(1, 52, 74)","id":"button-with-loading-lojistik"},on:{"click":function($event){return _vm.lojistikSiparisKayit()}}},[_vm._v("Lojistik Siparişi Kaydet")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }